import React from 'react';
import { ConstructorRequestType } from '../../../Enums/constructors';
import QuotationForm from './QuotationForm';
import AditonalJobForm from './AditionalJobForm';
import SubrogationForm from './SubrogationForm';

const ConstructorRequestForm = ({ type, ...props }) => {
  switch (type) {
    case ConstructorRequestType.Quotation:
      return <QuotationForm {...props} />;
    case ConstructorRequestType.AditionalJob:
      return <AditonalJobForm {...props} />;
    case ConstructorRequestType.Subrogation:
      return <SubrogationForm {...props} />;

    default:
      return <> </>;
  }
};

export default ConstructorRequestForm;
